import { alpha, styled } from '@mui/material';

export const ContentWrapper = styled('div')(({ theme }) => ({
  overflowWrap: 'break-word',
  '&& h1, h2, h3, h4': {
    margin: theme.spacing(3, 0, 2, 0),
  },
  '&& h5, h6': {
    margin: theme.spacing(2, 0),
  },

  '&& p': {
    lineHeight: 1.75,
    margin: theme.spacing(2, 0),
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(2.5, 0),
    },
  },
  '&& ul,ol': {
    lineHeight: 2,
  },
  '&& li > p': {
    margin: 0,
  },
  '&& ul li::marker': {
    fontSize: '0.6rem',
  },
  '.image-wrapper > span': {
    borderRadius: 4,
  },
  '.image-wrapper': {
    margin: theme.spacing(2, 0),
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(3, 0),
    },
  },
  '.player-wrapper': {
    margin: theme.spacing(2, 0),
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(3, 0),
    },
  },
  a: {
    '&:hover': {
      color: theme.vars.palette.grey[500],
      textDecoration: 'underline',
      textDecorationColor: alpha(theme.palette.grey[200], 0.3),
    },
    '&:active': {
      color: theme.vars.palette.grey[600],
      textDecoration: 'underline',
      textDecorationColor: alpha(theme.palette.grey[500], 0.3),
    },
  },
}));
